// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import Vuetify from 'vuetify'
Vue.use(Vuetify)
import('vuetify/dist/vuetify.min.css') // Ensure you are using css-loader
import('./stylus/main.styl')

import VueSession from 'vue-session'
Vue.use(VueSession)

//global registration
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)

import VueCarousel from 'vue-carousel'
Vue.use(VueCarousel)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import 'nprogress/nprogress.css'
import NProgress from 'nprogress' // progress bar
import axios from 'axios' // HTTP client

window.axios = axios.create({
  baseURL: 'http://api.techfarmth.com/intranet-portal',
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

window.axios.interceptors.request.use(config => {
  // Called on request
  NProgress.start()
  return config
})
window.axios.interceptors.response.use(response => {
  // Called on response
  NProgress.done()
  return response
})

import iziToast from 'iziToast' // Alert css
window.iziToast = iziToast
import swal from 'sweetalert2'
window.swal = swal


Vue.prototype.$appVersion = 'v1.2.41'
Vue.prototype.$appName = 'Intranet Portal'
Vue.prototype.$apiHost = 'http://api.techfarmth.com/intranet-portal/'

Vue.config.productionTip = false

import firebase from 'firebase'
var config = {
  apiKey: 'AIzaSyDkT9HtUvN4b_L0jX63m1TChS6V4615Gak',
  authDomain: 'intranet-portal-f74de.firebaseapp.com',
  databaseURL: 'https://intranet-portal-f74de.firebaseio.com',
  projectId: 'intranet-portal-f74de',
  storageBucket: 'intranet-portal-f74de.appspot.com',
  messagingSenderId: '13349397215'
}
firebase.initializeApp(config)
Vue.use(firebase)

// set all components to global component
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context(
  './components',
  false,
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
  )

  Vue.component(componentName, componentConfig.default || componentConfig)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  created() {
    // console.log(location.protocol)
    // console.log(process.env.NODE_ENV)
    // if (location.protocol != 'https:' && process.env.NODE_ENV != 'development') {
    //   location.href = 'https:' + window.location.href.substring(window.location.protocol.length)
    // }
    // if (!this.$session.exists()) {
    //   this.$router.push({ name: 'UserLogin' })
    // }
    localStorage.getItem('running-site') !== 'portal'
      ? localStorage.setItem('running-site', 'portal')
      : ''
    if (
      localStorage.getItem('appversion') === null ||
      localStorage.getItem('appversion') !== this.$appVersion
    ) {
      // update new app version
      localStorage.setItem('appversion', this.$appVersion)

      // delete localStorage
      localStorage.removeItem('userid')
      localStorage.removeItem('roleid')
      localStorage.removeItem('productsTHA')
      // delete session
      this.$session.destroy()
    }
    if (localStorage.getItem('userid') === null) {
      this.$router.push({ name: 'UserLogin' })
    } else {
      this.$session.set('userid', localStorage.getItem('userid'))
    }
  },
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js